import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { pages } from './allPages';

type AppRoutesProps = {
  routes: any[];
  children?: React.ReactNode;
  isPublic?: boolean;
};

export function AppRoutes(props: AppRoutesProps) {
  const { routes } = props;

  function renderRoute(route: any) {
    const { id, path, elementId } = route;

    const Cmp = (pages as any)[elementId];

    if (!Cmp) return null;

    return <Route key={id} path={path} element={<Cmp {...route.props} />} />;
  }

  function renderRoutes() {
    return routes
      .filter((route: any) => {
        if (props.isPublic) return route.isPublic;
        return !route.isPublic;
      })
      .map((route: any) => renderRoute(route));
  }

  function renderCatchAll() {
    if (!props.children) return;
    return <Route path='/*' element={props.children} />;
  }

  return (
    <Routes>
      {renderRoutes()}
      {renderCatchAll()}
    </Routes>
  );
}
